import React from 'react'
import './Styles/StepperStyle.css'
export default function Loading() {
  return (
    <div id="load" >
    <div>G</div>
    <div>N</div>
    <div>I</div>
    <div>D</div>
    <div>A</div>
    <div>O</div>
    <div>L</div>
    </div>
  )
}
